import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

export default function MainBlock() {
  const { t } = useTranslation()

  return (
    <div className={cn('container', styles.mainBlock)}>
      <h1 className={styles.mainBlockTitle}>{t('what_we_believe')}</h1>
      <div className={styles.mainBlockText}>{t('crypto_work_now')}</div>
    </div>
  )
}
